module.exports = __webpack_public_path__ + "static/scen-1-015e8dfcc4c6fac77a600fb9b3e97ae3.svg";